<section>
  <div class="container-style">
    <div class="row align-items-center py-2">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6 class="mx-0">
          {{ isFormView ? 'Registrar detalle del modelo contable' : 'Detalle del modelo contable' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-2">
        <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail()"
          [width]="'6.5rem'" (onClick)="createNewDetail()"></app-custom-button>
      </div>
    </div>
    <div [hidden]="!isFormView" class="row mx-0">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-accounting-model-detail [accountingModelModel]="accountingModelModel()"
          [accountingModelDetailContract]="accountingModelDetailModel"
          (updateListDetail)="getAccountingModelDetailsByAccountingModel()"
          (isFormView)="getFormView($event)"></app-register-accounting-model-detail>
      </div>
    </div>
    <div class="row mb-2">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]="!disabledDetail()" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getAccountingModelDetailsByAccountingModel()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>